<template>
  <form
    :action="uploadFile"
    enctype="multipart/form-data"
    class="position-relative"
    data-component="FilesSender"
    :data-files-count="filesCount"
  >
    <!-- -->
    <slot name="slotTeleversement" :filesCount="filesCount" :addFile="mixinAddFile_addFile"> </slot>
    <!--  -->
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import mixinAddFile from '@/mixins/mixinAddFile';
import { getApiUrlContext } from '@/helpers/AppHelpers';

export default {
  name: 'FileSender',
  mixins: [mixinAddFile],

  data() {
    return {
      fileNameLengthMax: 30,
      fileMaxSize: 0,
      fileTypes: [],
      filesCount: 0,
      filesMax: 2,
      files: [],
      filesWeakmap: new WeakMap(),
    };
  },

  computed: {
    ...mapGetters(['getAccountUserMessages']),

    $dropzone() {
      return document.querySelector('body');
    },

    uploadFile() {
      return getApiUrlContext('upload-doc', 'televersementLoadUpload');
    },
  },

  methods: {
    setTeleversementInfo(data) {
      this.fileMaxSize = data.fileMaxSize;
      this.fileTypes = data.fileTypes;
    },
    removeFile(file, elementPosition) {
      const vm = this;
      return function () {
        // Remove the element from the Array of names, items and the DOM
        const $file = this.parentElement.children[1].closest('[data-is="file"]');
        $file.parentElement.removeChild($file);

        vm.filesWeakmap.delete($file);
        for (let i = 0; i < vm.files.length; i++) {
          if (vm.files[i] === file) {
            vm.files.splice(i, 1);
          }
        }

        document
          .querySelector(`#cadre-selection-document-${elementPosition}`)
          .classList.add('bordure-cadre-opaque');
        document
          .querySelector(`#cadre-selection-document-${elementPosition}`)
          .classList.remove('bordure-cadre-transparent');

        if (vm.filesCount == 2) {
          document.querySelector('#televersement__warnings').classList.add('d-none');

          const nomIdentique = document.querySelectorAll('#televersement__errors');
          for (let i = 0; i < nomIdentique.length; i++) {
            nomIdentique[i].classList.add('d-none');
            nomIdentique[i].querySelector('#error-identical-name').classList.add('d-none');
          }
          vm.enableDragNDrop();
        }

        if (elementPosition == 'premier') {
          vm.doc1Selectionne = null;
        } else {
          vm.doc2Selectionne = null;
        }

        vm.filesCount--;
      };
    },

    showError(errorsToEdit, errorId, uploadElementPosition) {
      errorsToEdit.classList.remove('d-none');
      errorsToEdit.querySelector(`#${errorId}`).classList.remove('d-none');
      document
        .querySelector(`#cadre-selection-document-${uploadElementPosition}`)
        .classList.remove('cadre-selection-document');
      document
        .querySelector(`#cadre-selection-document-${uploadElementPosition}`)
        .classList.add('cadre-selection-document-invalide');
    },

    hideErrors(errorsToEdit, uploadElementPosition) {
      errorsToEdit.classList.add('d-none');
      errorsToEdit = errorsToEdit.querySelectorAll('li');

      for (let i = 0; i < errorsToEdit.length; i++) {
        errorsToEdit[i].classList.add('d-none');
      }
      document
        .querySelector(`#cadre-selection-document-${uploadElementPosition}`)
        .classList.add('cadre-selection-document');
      document
        .querySelector(`#cadre-selection-document-${uploadElementPosition}`)
        .classList.remove('cadre-selection-document-invalide');
    },

    showWarning(warningsToEdit, warningId) {
      warningsToEdit.classList.remove('d-none');
      warningsToEdit.querySelector(`#${warningId}`).classList.remove('d-none');
    },

    hideWarnings(warningsToEdit) {
      warningsToEdit.classList.add('d-none');
      warningsToEdit = warningsToEdit.querySelectorAll('li');

      for (let i = 0; i < warningsToEdit.length; i++) {
        warningsToEdit[i].classList.add('d-none');
      }
    },

    dragOverHandler() {
      // eslint-disable-next-line no-restricted-globals
      event.preventDefault();
      document.querySelector('#glisser-deposer-overlay').classList.remove('invisible');
    },

    dragLeaveHandler() {
      document.querySelector('#glisser-deposer-overlay').classList.add('invisible');
    },

    dropHandler() {
      document.querySelector('#glisser-deposer-overlay').classList.add('invisible');
      if (!this.doc1Selectionne) this.uploadElementPosition = 'premier';
      else this.uploadElementPosition = 'deuxieme';
      if (this.filesCount === 2) {
        this.erreurNombreFichier.montrerMessage = true;
      } else {
        this.mixinAddFile_addFile();
        this.erreurNombreFichier.montrerMessage = false;
      }
    },

    enableDragNDrop() {
      this.$dropzone.addEventListener('dragleave', this.dragLeaveHandler);
      this.$dropzone.addEventListener('dragover', this.dragOverHandler);
      this.$dropzone.addEventListener('drop', this.dropHandler);

      // bloquer le tab opening sur drop de fichier quand tous les fichiers sont sélectionnés
      window.addEventListener(
        'dragover',
        function (e) {
          // eslint-disable-next-line no-restricted-globals
          e = e || event;
          e.preventDefault();
        },
        false
      );
      window.addEventListener(
        'drop',
        function (e) {
          // eslint-disable-next-line no-restricted-globals
          e = e || event;
          e.preventDefault();
        },
        false
      );
    },

    errorsReset(erreurs) {
      for (let i = 0; i < erreurs.length; i++) {
        erreurs[i].classList.add('d-none');
      }
    },
  },
};
</script>
